import { render, staticRenderFns } from "./IconChatAlt2Outline.vue?vue&type=template&id=7f5a708f"
import script from "./IconChatAlt2Outline.vue?vue&type=script&lang=js"
export * from "./IconChatAlt2Outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports